import { render, staticRenderFns } from "./PortfolioGenerators.vue?vue&type=template&id=69f3b21a"
import script from "./PortfolioGenerators.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioGenerators.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports